import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 导入统一的API配置
import { API_CONFIG } from './api/config'
// 导入ECharts组件和渲染器
import ECharts from 'vue-echarts'
// 手动引入 ECharts 各模块来减小打包体积
import { use } from 'echarts/core'
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  LineChart,
  BarChart,
  PieChart
} from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'

// 注册必须的组件
use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

Vue.config.productionTip = false

// 使用Element UI
Vue.use(ElementUI)

// 注册ECharts组件
Vue.component('v-chart', ECharts)

// 使用统一的API服务
import request from './api/request'
Vue.prototype.$http = request

// 开发环境下，在全局添加调试工具
if (API_CONFIG.DEBUG) {
  const { clearAdminSession } = require('./utils/auth')
  window.clearAdminSession = clearAdminSession
  window.API_CONFIG = API_CONFIG
  console.log('开发工具已加载：')
  console.log('- clearAdminSession(): 清除管理员登录状态')
  console.log('- API_CONFIG: 查看API配置信息')
  console.log('- 当前API地址:', API_CONFIG.BASE_URL)
}

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
